import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Header,
  HeaderLeft,
  HeaderText,
  HeaderRight,
  LogoVale,
  LogoNtt,
  UserAvatar,
  AvatarMenuWrapper,
  AvatarMenuTrigger,
  MenuPopupContainer,
  MenuPopupItem,
} from './Topbar.style';
import { LogoValeImage, LogoNttImage, UserAvatarImage } from '@images';
import { useMsal } from '@azure/msal-react';
import { clearTokens } from '@utils/token/token.storage';

const USER_MENU_ID = 'header-user-menu';

export function Topbar() {
  const { instance } = useMsal();
  const [menuOpen, setMenuOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const logout = async () => {
    instance.setActiveAccount(null);
    try {
      await instance.clearCache({});
    } catch {
      /* ignore */
    }
    clearTokens();
    /* navigate('/login') perde contra AuthLoginRoute se isAuthenticated ainda for true um frame.
       replace força recarga: MSAL + Router ficam alinhados com sessão terminada. */
    window.location.replace(`${window.location.origin}`);
  };

  useEffect(() => {
    if (!menuOpen) return;

    function onDocMouseDown(e: MouseEvent) {
      if (!wrapperRef.current?.contains(e.target as Node)) {
        closeMenu();
      }
    }

    document.addEventListener('mousedown', onDocMouseDown);

    return () => {
      document.removeEventListener('mousedown', onDocMouseDown);
    };
  }, [menuOpen, closeMenu]);

  return (
    <Header>
      <HeaderLeft>Praça Digital Partilhar</HeaderLeft>
      <HeaderRight>
        <AvatarMenuWrapper ref={wrapperRef}>
          <AvatarMenuTrigger
            type="button"
            aria-label="Menu do usuário"
            aria-expanded={menuOpen}
            aria-haspopup="menu"
            aria-controls={USER_MENU_ID}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <UserAvatar src={UserAvatarImage} alt="" />
          </AvatarMenuTrigger>
          {menuOpen && (
            <MenuPopupContainer id={USER_MENU_ID} role="menu" aria-label="Conta">
              <MenuPopupItem
                type="button"
                role="menuitem"
                onClick={() => {
                  void logout();
                }}
              >
                Desconectar
              </MenuPopupItem>
            </MenuPopupContainer>
          )}
        </AvatarMenuWrapper>
      </HeaderRight>
    </Header>
  );
}
